import axios from "axios";
import {apiHost} from "../pages/common/Global";
import { store } from '../redux/store';
import { accountActions } from '../redux/actions/account';

const proxy = "";
// const proxy = "https://ziha-proxy-bef22eb1e8af.herokuapp.com/";

// axios 인스턴스 생성
const instance = axios.create({
    baseURL: apiHost,
    headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
    },
    withCredentials: true
});

// 요청 인터셉터 - sessionId를 모든 요청에 포함
instance.interceptors.request.use(
    (config) => {
        // OPTIONS 요청인 경우 세션 ID를 추가하지 않음
        if (config.method === 'options') {
            return config;
        }

        // 로그인 API 호출 시에는 세션 ID를 포함하지 않음
        const isLoginRequest = config.url && (
            config.url.includes('/aLoginSession') || 
            config.url.includes('/login')
        );
        
        if (isLoginRequest) {
            return config;
        }

        try {
            const state = store.getState();
            const sessionId = state?.account?.sessionId;

            if (sessionId) {
                config.headers['X-Session-Id'] = sessionId;
            }
        } catch (error) {
            console.error('Error getting sessionId from store:', error);
        }
        
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// 응답 인터셉터 - 401 에러 처리
instance.interceptors.response.use(
    (response) => {
        return response;
    },
    (error) => {
        if (error.response && error.response.status === 401) {
            // 세션 만료 처리
            try {
                // 세션 정보 초기화
                store.dispatch(accountActions.initAccount());
                
                // alert 표시
                window.alert('세션이 만료되었습니다. 다시 로그인해주세요.');
                
                // HashRouter를 사용하므로 경로 앞에 # 추가
                window.location.href = '/#/login';
            } catch (err) {
                console.error('Error handling 401 response:', err);
                window.location.href = '/#/login';
            }
        }
        return Promise.reject(error);
    }
);

// 기본 HTTP 메서드들
export function post(request, body) {
    return instance.post(proxy + request, body);
}

export function postQueryString(request, config) {
    return instance.post(proxy + request, null, config);
}

export function get(request, body) {
    return instance.get(proxy + request, {
        params: body
    });
}

export function put(request, body, config) {
    return config ? instance.put(proxy + request, body, config) : instance.put(proxy + request, body);
}

export function patch(request, body) {
    return instance.patch(proxy + request, body);
}

export function deleteM(request, body) {
    return instance.delete(proxy + request, {params: body});
}

// API 호스트 URL 생성 헬퍼
export function createApiUrl(endpoint) {
    return apiHost + endpoint;
}

// 공통 에러 처리
export function handleApiError(error) {
    console.error('API Error:', error);
    if (error.response) {
        // 서버가 응답했지만 에러 상태
        console.error('Response data:', error.response.data);
        console.error('Response status:', error.response.status);
    } else if (error.request) {
        // 요청이 전송되었지만 응답을 받지 못함
        console.error('No response received:', error.request);
    } else {
        // 요청 설정 중 에러 발생
        console.error('Error setting up request:', error.message);
    }
    throw error;
}

// axios 인스턴스 export (다른 모듈에서 사용할 수 있도록)
export { instance };
